import { queriesPersons } from "@query";
import {
  Stakeholder,
  StakeholderSubjectType
} from "@wingspanhq/wingspan-api-sdk";

export const useStakeholderPerson = (stakeholder: Stakeholder) =>
  queriesPersons.getPerson.useQuery(
    { personId: stakeholder.subjectId as string },
    {
      enabled:
        stakeholder.subjectType === StakeholderSubjectType.PERSON &&
        !!stakeholder.subjectId
    }
  );
